import { ProductAggregatedStatDeklaracjeSum } from "@/store/modules/statsDeklaracje/types";


export class State {
    aggregatedStatsDeklaracjeSumUpdating: boolean = false;
    aggregatedStatsDeklaracjeSum: Array<ProductAggregatedStatDeklaracjeSum> = [];
    aggregatedStatsDeklaracjeSumBuffer: Array<ProductAggregatedStatDeklaracjeSum> = [];



    detailedStatsDeklaracjeLoading: boolean = false;
    detailedStatsDeklaracje: Array<object> = [];
}


